module.exports = __webpack_public_path__ + "static/media/ic_link_pinterest.f94d1da7.svg";